/**
 * Image input field.
 * https://martinit.atlassian.net/browse/KCA-113
 */
import {Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef} from "@angular/core";
//import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SafeUrl } from '@angular/platform-browser';
import {UntypedFormControl, Validators} from "@angular/forms";
import {Answer} from "../../../../swaggerServices";
import {IAnswer, IFormField} from "../form-field-wrapper/form-field-wrapper.component";
import { RubixDocumentsService } from "../../../app/tax-returns/tax-return/rubix-documents/rubix-documents.service";

enum FileStatus {
  Error = "Error",
  NoneSelected = "None",
  Original = "Original",
  Uploading = "Uploading",
  Updated = "Updated", // any changes from an initial state (NoneSelected or Original)
};

@Component({
    selector: "app-image-field",
    templateUrl: "./image-field.component.html",
    styleUrls: ["./image-field.component.scss"],
    standalone: false
})
export class ImageFieldComponent implements OnInit {
  @Input() question: IFormField;
  @Input() myFormControl: UntypedFormControl;
  @Input() disabled?: boolean;
  @Input() tabIndex?: number = 0;
  @Input() lockOnlyDisabledValue?: boolean = false;
  @Output() answer: [Answer];

  @ViewChild('inputEl') inputEl: ElementRef;

  fileStatus: FileStatus;
  imageUrl: SafeUrl;
  imageMaxWidth: string;
  imageMaxHeight: string;
  errorMessage: string;
  loadingImage: boolean = false;

  constructor(
//    private domSanitizer: DomSanitizer,
//    private rubixDocumentService: RubixDocumentsService
  ) {}

  private getImageBoundingDimensions() {
    if (this.question.valueFormat) {
      const dimensions = this.question.valueFormat.split(",");
      if (dimensions.length === 1) { dimensions.push(null); }
      return {
        width: +dimensions[0] || null,
        height: +dimensions[1] || null
      };
    }

    return {
      width: null,
      height: null,
    };
  }

  ngOnInit() {
    this.fileStatus = FileStatus.NoneSelected;
    const dimensions = this.getImageBoundingDimensions();
    this.imageMaxWidth = dimensions.width ? `${dimensions.width}px` : null;
    this.imageMaxHeight = dimensions.height ? `${dimensions.height}px` : null;

    if (this.myFormControl.value) {
      const imageObj = JSON.parse(this.myFormControl.value);
      this.fileStatus = FileStatus.Original;
      this.renderPreviewImage(imageObj);
    }
  }

  private renderPreviewImage(imageObj) {
    this.loadingImage = true;
    const dimensions = this.getImageBoundingDimensions();
    if (imageObj && !imageObj.imageId) {
      this.loadingImage = false;
      this.errorMessage = "Unable to load image preview due to missing imageId";
      return;
    }
    // if (imageObj && imageObj.imageId) {
    //   this.rubixDocumentService.downloadImage(imageObj.imageId, dimensions).subscribe(
    //     ({ fileName, fileContent }) => {
    //       this.loadingImage = false;
    //       if (!fileContent)  {
    //         this.errorMessage = "Unable to load image preview";
    //         return;
    //       }
    //       const previewUrl = `data:image/jpeg;base64,${fileContent}`;
    //       this.imageUrl = this.domSanitizer.bypassSecurityTrustUrl(previewUrl);
    //     }, (error) => {
    //       this.errorMessage = error.message;
    //       this.loadingImage = false;
    //     });
    // }
  }

  initFile(files: any) {
    if (!files) {
      this.imageUrl = null;
      this.fileStatus = FileStatus.Updated;
      return;
    }

    const sourceFile = files[0];
    this.fileStatus = FileStatus.Uploading;
    this.errorMessage = null;
    this.myFormControl.setErrors({
      isUploading: true,
    });
    // this.rubixDocumentService.uploadImage(sourceFile).subscribe(
    //   ({fileName, imageId, imageFolder}) => {
    //     this.fileStatus = FileStatus.Updated;
    //     const imageObj = { name: fileName, imageId: imageId };
    //     this.myFormControl.setValue(JSON.stringify(imageObj));
    //     this.myFormControl.setErrors({
    //       isUploading: false,
    //     });
    //     this.renderPreviewImage(imageObj);
    // }, (error) => {
    //   this.fileStatus = FileStatus.Error;
    //   this.errorMessage = error.message;
    //   this.myFormControl.setErrors({});
    // });
  }

  removeImage() {
    this.myFormControl.reset();
    this.imageUrl = null;
    this.fileStatus = FileStatus.Updated;
    this.inputEl.nativeElement.value = null;
  }
}

const imageFieldValidators = (q: IFormField) => {
  const validators = [];
  if (q.mandatory) validators.push(Validators.required);
  return validators;
};

export const makeImageFieldFormControl = (q: IFormField, answer?: IAnswer) => {
  const formControlValue = answer ? answer.answer : (q.default != null ? String(q.default) : "");
  q.validators = imageFieldValidators(q);
  const formControl = new UntypedFormControl(formControlValue, {validators: Validators.compose(q.validators)});
  if (!answer && formControlValue) {
    formControl.markAsDirty();
  }
  return formControl;
};
